import { OrderHistoryEventDTO } from 'entities/orderHistory/model/dtoTypes'
import { OrderHistoryEvent } from 'entities/orderHistory/model/types'

export const adaptOrderHistoryDTO = (dto: OrderHistoryEventDTO): OrderHistoryEvent => ({
    event: dto.event,
    details: dto.details,
    description: dto.description,
    adminId: dto.admin_id,
    createdAt: new Date(dto.created_at),
})